import { render } from "./CategoryManager.vue?vue&type=template&id=164464cd&scoped=true"
import script from "./CategoryManager.vue?vue&type=script&lang=js"
export * from "./CategoryManager.vue?vue&type=script&lang=js"

import "./CategoryManager.vue?vue&type=style&index=0&id=164464cd&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164464cd"]])

export default __exports__